import type { StufenBeschreibung } from '@luzula/luzula-lib';
import { grauTreppe } from './stufen-farbtreppe';

/**
 * Substanzvolumen (SV) — Anteil fester Substanz am Gesamtvolumen, Spalte im
 * Moorprotokoll. Eingabewert 1 … 5.
 *
 * Die Reihe liegt hier, weil zwei Stellen sie brauchen: der Hilfetext am (i)
 * (`substanzvolumenHilfetext`) und das Stufen-Feld in der Substratfolge
 * (`SUBSTANZVOLUMEN_STUFEN_FELD`).
 */
export interface SubstanzvolumenStufe {
	wert: number;
	/** Spanne in Volumen-%. */
	spanne: string;
	/** Zusatz aus der Anweisung; nicht jede Stufe führt einen. */
	zusatz?: string;
}

export const SUBSTANZVOLUMEN_STUFEN: SubstanzvolumenStufe[] = [
	{ wert: 1, spanne: '< 3 %', zusatz: 'Mudden, stark wasserhaltig' },
	{ wert: 2, spanne: '3–5 %' },
	{ wert: 3, spanne: '5–8 %' },
	{ wert: 4, spanne: '8–12 %' },
	{ wert: 5, spanne: '> 12 %' },
];

/** Der Hilfetext am (i) — wortgleich mit dem bisherigen Text im Hilfedienst. */
export function substanzvolumenHilfetext(): string {
	const zeilen = SUBSTANZVOLUMEN_STUFEN.map(s => `${s.wert} — ${s.spanne}${s.zusatz ? ` (${s.zusatz})` : ''}`);
	return 'Substanzvolumen (SV) — Anteil fester Substanz am Gesamtvolumen\n\n' + zeilen.join('\n');
}

/** Für das Stufen-Feld: keine eigene Legende, deshalb die graue Treppe; als Name die Spanne. */
export const SUBSTANZVOLUMEN_STUFEN_FELD: StufenBeschreibung[] = (() => {
	const farben = grauTreppe(SUBSTANZVOLUMEN_STUFEN.length);
	return SUBSTANZVOLUMEN_STUFEN.map((s, i) => ({ wert: s.wert, farbe: farben[i], name: s.spanne }));
})();
